_options$originalPath